import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DetailModalFlightResultComponent } from './detail-modal-flight-result/detail-modal-flight-result.component';

@Component({
  selector: 'usb-flight-result',
  templateUrl: './flight-result.component.html',
  styleUrls: ['./flight-result.component.scss']
})
export class FlightResultComponent implements OnInit {
  @Input() payload: any;
  @Input() _form: any;
  @Input() result: any;
  @Input() arrayResults: any;
  @Input() index: number;
  @Input() form: FormGroup;
  @Input() currencies: any[];
  @Input() origin: string;
  @Input() mapView: Boolean = false;
  @Input() itineraryCurrency: string = '';
  @Input() clientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Input() qtyProductValid: number;
  @Input() paymentAgencyActive: any;
  @Output() coordinatesClicked = new EventEmitter<any>();
  @Output() modalClosedemitter = new EventEmitter<any>();
  @Output() qtyProductValidDecrementEmmit = new EventEmitter<any>();

  modalRef: BsModalRef;
  fontSizeAdjustments = { 6: -12, 9: -15, 12: -19 };
  stylePathPrice: any;
  formLocal:any;
  originalResult: any;
  constructor(
              public userService: UserService,
              private modalService: BsModalService
              ) { }

  ngOnInit(): void {
        this.formLocal = JSON.parse(localStorage.getItem('form'));
        this.stylePathPrice = JSON.parse(this.clientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
        this.originalResult = this.deepCopy(this.result);
  }

      // Método para deep copy
  private deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (obj instanceof Array) return obj.map(item => this.deepCopy(item));

    const copiedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        copiedObj[key] = this.deepCopy(obj[key]);
      }
    }
    return copiedObj;
  }

  openModalDetail(flightData: any): void {
    const initialState = {
      flightData: flightData
    };

    this.modalRef = this.modalService.show(
      DetailModalFlightResultComponent,
      {
        initialState,
        class: 'modal-lg modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      }
    );
  }

  getCancellationPolicy(canllationPolicy: any): void {

  }


}
